const translationPath =
  "page.4uSalesContract.registers.beneficiarySuspensionsReason.";

export const buildTPath = (path: string) => translationPath + path;
